import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import client from "./src/components/apollo_utils/client";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./global.css";
import Main from './src/components/main';

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <Main>
      {element}
    </Main>
  </ApolloProvider>
);